import React, {useState} from 'react';
import ValidationError from "~/Components/Forms/ValidationError";

const AdminUserForm = ({values, errors, onChange}) => {

    const defaultFields = {
        email: '',
        password: '',
        first_name: '',
        last_name: '',

        phone: '',
        company: '',
    };

    const form = {...defaultFields, ...values};

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        onChange(formData);
    };

    return (
        <form>
            <div className="form-row">
                <div className="form-group col-md-6">
                    <label>First Name</label>
                    <input
                        onChange={handleChange}
                        value={form.first_name}
                        name="first_name"
                        type="text"
                        className="form-control"/>

                    <ValidationError errors={errors} name="first_name" />
                </div>
                <div className="form-group col-md-6">
                    <label>Last Name</label>
                    <input
                        onChange={handleChange}
                        value={form.last_name}
                        name="last_name"
                        type="text"
                        className="form-control"/>

                    <ValidationError errors={errors} name="last_name" />
                </div>
            </div>
            <div className="form-group">
                <label>Email</label>
                <input
                    onChange={handleChange}
                    value={form.email}
                    name="email"
                    type="text"
                    className="form-control"/>

                    <ValidationError errors={errors} name="email" />
            </div>
            <div className="form-group">
                <label>Password</label>
                <input
                    onChange={handleChange}
                    value={form.password}
                    name="password"
                    type="text"
                    className="form-control"/>

                    <ValidationError errors={errors} name="password" />
            </div>
            <div className="form-group">
                <label>Phone number</label>
                <input
                    onChange={handleChange}
                    value={form.phone}
                    name="phone"
                    type="text"
                    className="form-control"/>

                    <ValidationError errors={errors} name="phone" />
            </div>
            <div className="form-group">
                <label>Company</label>
                <input
                    onChange={handleChange}
                    value={form.company}
                    name="company"
                    type="text"
                    className="form-control"/>

                    <ValidationError errors={errors} name="company" />
            </div>
        </form>
    );
}


export default AdminUserForm;
